import { ContinueButton } from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import { gsap } from "gsap";
import { Graphics, Sprite } from "pixi.js";

import { AbstractSymbol } from "../../elements/AbstractSymbol";
import { AbstractBitmapText } from "../../graphics/AbstractBitmapText";
import { AbstractSpine } from "../../graphics/AbstractSpine";
import { ITotalWinScreenData } from "../../types/interfaces";
import { AbstractScreen } from "./AbstractScreen";

export class AbstractWinScreen extends AbstractScreen {
    protected bgGraphics: Graphics;
    protected winTextBackground: Sprite;
    protected totalWinText: AbstractBitmapText;
    protected activeSpines: AbstractSpine[];
    protected currentSoundName: string = ``;
    protected continueButton: ContinueButton;

    protected get totalWinTextDefaultYPosition(): number {
        return 0;
    }

    protected get waysWinTextDefaultYPosition(): number {
        return 0;
    }

    protected init() {
        super.init();

        this.activeSpines = [];
    }

    // eslint-disable-next-line no-unused-vars
    public handleTinyWins(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleSmallWins(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public onSmallWinsComplete(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleMediumWins(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleLargeWins(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleBigWins(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public onBigWinsComplete(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleMaxCap(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public onMaxCapComplete(data: ITotalWinScreenData): void {}

    // eslint-disable-next-line no-unused-vars
    public handleWaysWin(symbols: AbstractSymbol[], winAmounts: number[], ways: number): void {
        //to be removed
    }

    // eslint-disable-next-line no-unused-vars
    public finish(data: ITotalWinScreenData): void {}

    public showWaysWin(
        waysWon: number,
        duration: number = 0.5
    ): gsap.core.Timeline | gsap.core.Tween {
        return gsap.timeline({ duration: duration });
    }
}
